export default function seatCalculatorInit() {
	if (document.querySelector("[data-select='calculatorApplicationData']")) {
		const applicationData = JSON.parse(document.querySelector("[data-select='calculatorApplicationData']").textContent);
		const calculatorInput = document.querySelector("#priceCalculatorInput");
		const increaseBtn = document.querySelector("[data-select='increase']");
		const reduceBtn = document.querySelector("[data-select='reduce']");

		// Reisepreis
		const primaryPrice = applicationData['primaryPriceSpecification'];
		const additionalPrices = applicationData['priceSpecifications'];

		// Anzahl der freien Plätze erhöhen
		increaseBtn.addEventListener('click', function () {
			var inputValue = parseInt(calculatorInput.value);

			// Dummy ... max gruppengröße?
			if (inputValue < parseInt(primaryPrice['groupSize'])) {
				inputValue++;
				calculatorInput.value = inputValue;

				priceCalculation(primaryPrice, additionalPrices, inputValue);
			}
		});

		// Anzahl der freien Plätze verringern
		reduceBtn.addEventListener('click', function () {
			var inputValue = parseInt(calculatorInput.value);

			if (inputValue > 0) {
				inputValue--;
				calculatorInput.value = inputValue;

				priceCalculation(primaryPrice, additionalPrices, inputValue);
			}
		});
	}

	function priceCalculation(primaryPrice, addPrices, freePersons) {
		// Haupt-Reisepreis berechnen
		const groupSize = parseInt(primaryPrice['groupSize']) - parseInt(primaryPrice['includedComplimentarySeats']);
		const calculatedPrice = (primaryPrice['price'] * groupSize) / (groupSize - freePersons);

		if (calculatedPrice) {
			updatePriceData(
				"primaryPriceBlock",
				roundPrice(calculatedPrice),
				freePersons
			);
		}

		// alternative Preise berechnen
		if (addPrices) {
			addPrices.forEach(function(addPrice) {
				const groupSize = parseInt(addPrice['groupSize']) - parseInt(addPrice['includedComplimentarySeats']);
				const calculatedAltPrice = (addPrice['price'] * groupSize) / (groupSize - freePersons);

				if (calculatedAltPrice) {
					updatePriceData(
						"alternativePrice_" + addPrice['groupSize'],
						roundPrice(calculatedAltPrice),
						freePersons);
				}
			});
		}
	}

	function updatePriceData(identifier, calculatedPrice, freePersons) {
		const priceElement = document.querySelector("[data-select='" + identifier + "']");

		if (freePersons > 0 && calculatedPrice) {
			const formattedPrice = calculatedPrice.toFixed(2).toString().replace('.', ',');
			var freePersonsText = freePersons + " Freiplätzen";
			if (freePersons == 1) {
				freePersonsText = "einem Freiplatz";
			}

			priceElement.querySelector("[data-select='freePersonsColumn']").textContent = freePersonsText;
			priceElement.querySelector("[data-select='priceValueColumn']").textContent = formattedPrice;
		}

		priceElement.classList.toggle("alternativePriceRowHidden", (freePersons === 0));
	}

	function roundPrice(calculatedPrice) {
		const roundPrice = Math.round(calculatedPrice);
		if (roundPrice < calculatedPrice) {
			return (roundPrice + 0.5);
		} else {
			return roundPrice
		}
	}
}

seatCalculatorInit();
